import { useEffect, useState } from 'react';
import { ChatInterface } from './components/ChatInterface';
import { ChatInterfaceSingle } from './components/ChatInterfaceSingle';
import './App.css';

function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const handler = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  return (
    <div className="h-screen">
      {path === '/multi' ? <ChatInterface /> : <ChatInterfaceSingle />}
    </div>
  );
}

export default App;
